import {
  Button,
  DropDown,
  Icon,
  IconButton,
  Modal,
  RadioGroup,
  Text,
} from 'components'
import { useForm } from 'react-hook-form'
import { useTheme, useToggle } from 'shared/hooks'

import { ThemeConfig } from 'domains/profile/screens/Management/types'

import { themeLabels } from './constants'

import { ChangePassword, ResetPassword, User } from './components'

import styles from './styles.module.scss'

const Management = () => {
  const { theme, setTheme, setBrowserPreference } = useTheme()

  const changePassword = useToggle()
  const resetPassword = useToggle()

  const { watch, register, setValue } = useForm<{ theme: ThemeConfig }>({
    defaultValues: {
      theme,
    },
  })

  const handleChangeTheme = (option: ThemeConfig) => {
    if (option === 'default') {
      setBrowserPreference()
    } else {
      setTheme(option)
    }

    setValue('theme', option)
  }

  return (
    <>
      {changePassword.isVisible && (
        <Modal.Root isOpen onClose={changePassword.hide}>
          <Modal.Content>
            <ChangePassword
              onResetPassword={() => {
                resetPassword.show()
                changePassword.hide()
              }}
            />
          </Modal.Content>
        </Modal.Root>
      )}

      {resetPassword.isVisible && (
        <Modal.Root isOpen onClose={resetPassword.hide}>
          <Modal.Content>
            <ResetPassword />
          </Modal.Content>
        </Modal.Root>
      )}

      <div className={styles.container}>
        <div className={styles.header}>
          <Text as="h2" size="2xl">
            Gerenciar conta
          </Text>
        </div>
        <div className={styles.content}>
          <User />

          <div className={styles.configs}>
            <Text size="lg">Outras configurações</Text>

            <div className={styles.option}>
              <Text weight="semibold">Alterar senha</Text>

              <IconButton onClick={() => changePassword.show()}>
                <Icon
                  width={16}
                  name="chevron-sm-right"
                  color="element-default"
                />
              </IconButton>
            </div>

            <div className={styles.option}>
              <Text weight="semibold">Aparência</Text>

              <DropDown.Root>
                <DropDown.Trigger>
                  <Button
                    {...register('theme')}
                    appearance="secondary"
                    width={128}
                    color="element"
                    className={styles.selectedTheme}
                  >
                    <Text weight="semibold">{themeLabels[watch('theme')]}</Text>

                    <Icon
                      width={10}
                      name="chevron-sm-down"
                      color="element-special"
                    />
                  </Button>
                </DropDown.Trigger>

                <DropDown.Content
                  className={styles.dropdown}
                  position="bottom"
                  offsetX={-200}
                >
                  <RadioGroup.Root className={styles.radio}>
                    {Object.entries(themeLabels).map(([key, value]) => (
                      <RadioGroup.Item
                        onClick={() => handleChangeTheme(key)}
                        className={styles.item}
                        key={key}
                      >
                        <div>
                          <RadioGroup.Label>{value}</RadioGroup.Label>

                          {key === 'default' && (
                            <RadioGroup.Label className={styles.description}>
                              Ajustaremos automaticamente a exibição com base
                              nas configurações de tema do seu dispositivo.
                            </RadioGroup.Label>
                          )}
                        </div>

                        <RadioGroup.Input
                          checked={watch('theme') === key}
                          value={value}
                          onChange={() => handleChangeTheme(key)}
                          appearance="neutral"
                        />
                      </RadioGroup.Item>
                    ))}
                  </RadioGroup.Root>
                </DropDown.Content>
              </DropDown.Root>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Management
